import createModule from "../createModule"
import view from "./view"
import { get, isObject, toUpper, size } from "lodash"
import { Creators as DialogCreators } from "modules/dialog/model"
import { getSortedModelsByCoverage, getModelsDates, getResourceType } from "./selectors"
import { generateCoverageQuery } from "./helpers"

export default createModule({
  view,
  externalProps: (state, props) => ({
    resourceType: getResourceType(state, props),
    resourceId: get(props, "resourceId"),
    account: state.global.selected.account,
    modelsDates: getModelsDates(state, props),
  }),
  required: ["account"],
  data: [{
    resource: "modelsAvailability",
    url: () => ({
      id: "models",
      query: "query { models { id, name, availability { currentDate, factorsStartDate, securitiesStartDate } } }",
    }),
  }, {
    resource: "modelsCoverage",
    url: ({ modelsDates, resourceType, resourceId }) => {
      if (!size(modelsDates) || !resourceId || !resourceType) {
        return null
      }

      const query = generateCoverageQuery(resourceType, modelsDates)

      if (isObject(resourceId)) {
        switch (resourceType) {
          case "swap":
          case "index":
            resourceId = resourceId.ticker
            break
          case "etf":
            resourceId = `${resourceId.ticker}.${resourceId.mic}`
            break
        }
      }

      return {
        id: `modelsCoverage-${resourceType}${resourceId}`,
        query,
        variables: {
          resourceId,
          resourceType: toUpper(resourceType),
          ticker: get(resourceId, "ticker"),
          mic: get(resourceId, "mic"),
          internalId: get(resourceId, "internalId"),
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    sortedModelsByCoverage: getSortedModelsByCoverage(state, props),
  }),
  actions: {
    openDialog: DialogCreators.open,
  },
})
